import React, {Component} from "react";
import {Link} from "react-router-dom";
import "./ExperienceItem.css";

import Hyperlink from "Hyperlink/Hyperlink";
import Icon from "Icon/Icon";

import {isViewportMobile} from "utils";

export default class ExperienceItem extends Component
{
	componentDidMount()
	{
		window.addEventListener("resize", () =>
		{
			this.forceUpdate();
		});
	}
	
	render()
	{
		let containerStyle = {};

		if(isViewportMobile())
		{
			containerStyle = {borderColor: this.props.color};
		}

		return (
			<div className="exp-item" style={containerStyle}>
				<div className="colored" style={{color: this.props.color}}>
					<div className="position">
						{this.props.position}
					</div>

					<div className="date">
						{this.props.date}
					</div>
				</div>

				<div className="plain">
					<div className="company">
						{this.props.company}
					</div>

					<Hyperlink href={this.props.url} className="url" newTab>
						{this.props.url}
					</Hyperlink>
				</div>

				{this.props.caseStudy &&
					<Link to={this.props.caseStudy}>
						<div className="case-study">
							<Icon title="Case Study">book</Icon>
						</div>
					</Link>
				}

				<div className="boxes">
					<div className="box" style={{backgroundColor: this.props.color}}></div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Experience/ExperienceItem/ExperienceItem.js